<template>
    <div class="section-container">
        <div class="row justify-content-center">
            <div class="col-10">
                <div  v-if="users.length <= 0" class="no-content text-center">
                    No Accounts Available
                </div>    

                <div v-if="users.length > 0" class="leaders-container">
                    <header class="overview-header text-center">
                        Addresses have confession counts, but are not matched to particular confessions - for anonymity. 
                    </header>
                    <div v-for="(user, index) in users.slice(0, 25)" :key="index" class="row no-gutters text-center leaders-row">
                        <div class="col-12 col-sm-2">                     
                            <header>
                                Id
                            </header>
                            <div class="leaders-content">
                               {{ index + 1 }}
                            </div> 
                        </div>
                        <div class="col-12 col-sm-7 address-col">
                            <header>
                                User
                            </header>
                            <div class="leaders-content">
                                {{ user.address }}
                            </div>                          
                        </div>
                        <div class="col-12 col-sm-3">                          
                            <header>
                                Confessions
                            </header>
                            <div class="leaders-content">
                                {{ user.confessions }}
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
        </div>        
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: 'leaderboard',
    computed: {
        ...mapGetters({
            users: 'getUsers'
        })
    },
    methods: {}
}
</script>

<style scoped lang="less">
@import "../assets/less/generic.less";
@backgroundColor: #3c3f44;

.no-content {
    margin-top: 120px;
}

.leaders-container {
    margin-top: 100px; 

    .overview-header {
        padding: 30px;
        color: #fff;
        font-size: 20px;
        background: @backgroundColor;
        border-bottom: 1px solid #fff;
    }
    .leaders-row {
        padding: 20px;
        color: #fff;
        background: @backgroundColor;
        border-bottom: 1px solid #fff;

        header {
            font-size: 12px;
            color: #ccc;
            padding-bottom: 10px;
        }

        .address-col {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
}

// Phone device
@media only screen and (max-width: 480px) {
    .leaders-container {
        .leaders-row {
            border-bottom: none;
            padding: 0;

            [class^='col'] {
                padding: 20px;
                border-bottom: 1px solid #fff;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/Accounts.vue